import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useEntityGraphContext } from '../Wrapper/EntityGraphProvider'
import { AccountCategoryDetails } from './AccountCategoryDetails'
import { AccountDetails } from './AccountDetails'

const nodeTypeComponents = {
  accountCategory: AccountCategoryDetails,
  account: AccountDetails
}

export const NodeDetails = ({ nodeId }) => {
  const { state } = useEntityGraphContext()
  const selectedItem = useMemo(() => state?.data?.nodes?.find(node => node.id === nodeId), [state, nodeId])

  const NodeTypeDetailsComponent = useMemo(() => {
    if (!selectedItem || !selectedItem.data?.entityProps?.type) return null
    return nodeTypeComponents[selectedItem.data.entityProps.type] || null
  }, [selectedItem])

  return (
    <>
      {NodeTypeDetailsComponent && !!selectedItem?.data?.entityProps && (
        <NodeTypeDetailsComponent {...selectedItem.data} />
      )}
    </>
  )
}

NodeDetails.propTypes = {
  nodeId: PropTypes.string.isRequired
}
